import { APIGet, APIUrl, AdminType, IAPIResponse } from "api/protocols";
import { CancelToken } from "axios";
import { ICustomer } from "redux/reducers/models/customer";
import { IBooking } from "redux/reducers/models/teetime";

export interface IGetKioskBookingLookupParams {
  booking_reference: string;
}

export interface IKioskBookingLookupResponse {
  booking: IBooking;
  customer: ICustomer;
  search_type: string;
}

export async function GetKioskBookingLookup(
  params: IGetKioskBookingLookupParams,
  useGlobalLoader: boolean,
  cancelToken?: CancelToken,
): Promise<IAPIResponse<IKioskBookingLookupResponse>> {
  return await APIGet<IKioskBookingLookupResponse>(
    APIUrl(AdminType.FacilityAdmin, "/kiosk/booking-lookup"),
    params,
    useGlobalLoader,
    cancelToken,
  );
}
